import { Grid } from "@mui/material";
import { InformBlock } from "components/common";
import useGetPreviousImp from "hooks/useGetPreviousImp";

const LastImpression = ({ caseId }: { caseId: number | undefined }) => {
  const text = useGetPreviousImp(caseId);
  return (
    <Grid item xs={12}>
      <InformBlock
        title="Recent Impression Info"
        text={text}
        sx={{ minHeight: "fit-content", borderRadius: "1em" }}
      />
    </Grid>
  );
};

export default LastImpression;
